import React from 'react';
import { Coin, Globe2, Pen, ReceiptCutoff, Shield, Tree } from 'react-bootstrap-icons';
const JudicalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
    <path d="M160-120v-80h480v80H160Zm226-194L160-540l84-86 228 226-86 86Zm254-254L414-796l86-84 226 226-86 86Zm184 408L302-682l56-56 522 522-56 56Z"/>
  </svg>
);

const HealthIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857q.09.083.176.171a3 3 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01zM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5"/>
    <path d="M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162z"/>
  </svg>
);

const RegulationsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
  </svg>
);

const ImmigrationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"/>
    <path d="M3.232 1.776A1.5 1.5 0 0 0 2 3.252v10.95c0 .445.191.838.49 1.11.367.422.908.688 1.51.688h8a2 2 0 0 0 2-2V4a2 2 0 0 0-1-1.732v-.47A1.5 1.5 0 0 0 11.232.321l-8 1.454ZM4 3h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>
  </svg>
);

const InfrastructureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
    <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"/>
  </svg>
);

const JusticeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
    <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"/>
  </svg>
);

const ScienceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M9.752 6.193c.599.6 1.73.437 2.528-.362.798-.799.96-1.932.362-2.531-.599-.6-1.73-.438-2.528.361-.798.8-.96 1.933-.362 2.532Z"/>
    <path d="M15.811 3.312c-.363 1.534-1.334 3.626-3.64 6.218l-.24 2.408a2.56 2.56 0 0 1-.732 1.526L8.817 15.85a.51.51 0 0 1-.867-.434l.27-1.899c.04-.28-.013-.593-.131-.956a9.42 9.42 0 0 0-.249-.657l-.082-.202c-.815-.197-1.578-.662-2.191-1.277-.614-.615-1.079-1.379-1.275-2.195l-.203-.083a9.556 9.556 0 0 0-.655-.248c-.363-.119-.675-.172-.955-.132l-1.896.27A.51.51 0 0 1 .15 7.17l2.382-2.386c.41-.41.947-.67 1.524-.734h.006l2.4-.238C9.005 1.55 11.087.582 12.623.208c.89-.217 1.59-.232 2.08-.188.244.023.435.06.57.093.067.017.12.033.16.045.184.06.279.13.351.295l.029.073a3.475 3.475 0 0 1 .157.721c.055.485.051 1.178-.159 2.065Zm-4.828 7.475.04-.04-.107 1.081a1.536 1.536 0 0 1-.44.913l-1.298 1.3.054-.38c.072-.506-.034-.993-.172-1.418a8.548 8.548 0 0 0-.164-.45c.738-.065 1.462-.38 2.087-1.006ZM5.205 5c-.625.626-.94 1.351-1.004 2.09a8.497 8.497 0 0 0-.45-.164c-.424-.138-.91-.244-1.416-.172l-.38.054 1.3-1.3c.245-.246.566-.401.91-.44l1.08-.107-.04.039Zm9.406-3.961c-.38-.034-.967-.027-1.746.163-1.558.38-3.917 1.496-6.937 4.521-.62.62-.799 1.34-.687 2.051.107.676.483 1.362 1.048 1.928.564.565 1.25.941 1.924 1.049.71.112 1.429-.067 2.048-.688 3.079-3.083 4.192-5.444 4.556-6.987.183-.771.18-1.345.138-1.713a2.835 2.835 0 0 0-.045-.283 3.078 3.078 0 0 0-.3-.041Z"/>
    <path d="M7.009 12.139a7.632 7.632 0 0 1-1.804-1.352A7.568 7.568 0 0 1 3.794 8.86c-1.102.992-1.965 5.054-1.839 5.18.125.126 3.936-.896 5.054-1.902Z"/>
  </svg>
);

const SpendingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
    <path d="M444-144v-80q-51-11-87.5-46T305-357l74-30q8 36 40.5 64.5T487-294q39 0 64-20t25-52q0-30-22.5-50T474-456q-78-28-114-61.5T324-604q0-50 32.5-86t87.5-47v-79h72v79q72 12 96.5 55t25.5 45l-70 29q-8-26-32-43t-53-17q-35 0-58 18t-23 44q0 26 25 44.5t93 41.5q70 23 102 60t32 94q0 57-37 96t-101 49v77h-72Z"/>
  </svg>
);
/**
 * Section information configuration for US Legislative Branch
 */
const sectionsInfo = {
  us: {
    legislative: {
      title: 'Legislative Branch',
      description: 'Established by Article I of the Constitution, the Legislative Branch consists of the House of Representatives and the Senate, which together form the United States Congress. The House of Representatives is made up of 435 elected members, divided among the 50 states in proportion to their total population. In addition, there are 6 non-voting members...',
      imageSrc: '/legislativeBranch.png',
      iconComponent: <Pen />,
      learnMoreLink: 'https://www.whitehouse.gov/about-the-white-house/our-government/the-legislative-branch/',
      externalLinks: [
        { label: 'congress.gov', url: 'https://www.congress.gov/' },
        { label: 'house.gov', url: 'https://www.house.gov/' },
        { label: 'senate.gov', url: 'https://www.senate.gov/' },
        { label: 'Congressional Record', url: 'https://www.congress.gov/congressional-record' }
      ]
    },
    executive: {
      title: "Executive Branch",
      description: "The executive branch carries out and enforces laws. It includes the president, vice president, the Cabinet, executive departments, independent agencies, and other boards, commissions, and committees. The president serves as the head of state, head of government, and Commander-in-Chief of the armed forces.",
      imageSrc: "/executiveBranch.png",
      learnMoreLink: "https://www.whitehouse.gov/about-the-white-house/our-government/the-executive-branch/",
      externalLinks: [
        { label: "whitehouse.gov", url: "https://www.whitehouse.gov/" },
        { label: "usa.gov", url: "https://www.usa.gov/" },
        { label: "Federal Register", url: "https://www.federalregister.gov/" },
        { label: "Executive Orders", url: "https://www.presidency.ucsb.edu/documents/presidential-documents-archive-guidebook/executive-orders" }
      ]
    },

    whitehouse: {
      departmentInfo: {
        name: 'White House',
        image: '/whiteHouse.png',
        missionStatement: 'The White House serves as the home and office of the President of the United States.',
        officialURL: 'https://www.whitehouse.gov',
        route: '/us/whitehouse'
      },
      mainFeeds: [
        {
          id: 'whitehouseBriefing',
          name: 'Briefing Room',
          apiParams: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: ''
        },
        {
          id: 'presidentialActions',
          name: 'Presidential Actions',
          apiParams: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at&filter_column=category&filter_string=Presidential%20Actions',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Document'
        },
        {
          id: 'presidentialDocuments',
          name: 'Presidential Documents',
          apiParams: '&skip=0&schema=united_states_of_america&table=compilation_of_presidential_documents&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Doc'
        },
        {
          id: 'presidentialProclamations',
          name: 'Presidential Proclamations',
          apiParams: '&skip=0&schema=united_states_of_america&table=presidential_proclamation&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Document'
        }
      ],
      agencies: []
    },
    judicial: {
      title: "Judicial Branch",
      description: "Article III of the Constitution, which establishes the Judicial Branch, leaves Congress significant discretion to determine the shape and structure of the federal judiciary.",
      imageSrc: "/executiveBranch.png",
      iconComponent: <JudicalIcon/>,
      learnMoreLink: "https://www.whitehouse.gov/about-the-white-house/our-government/the-judicial-branch/"
    },
    defense: {
      title: "Defense",
      iconComponent: <Shield/>,
    },
    elections: {
      title: "Elections",
      iconComponent: <ReceiptCutoff/>,
    },
    economy: {
      title: "Economy",
      iconComponent: <Coin/>,
    },
    environment: {
      title: "Environment",
      iconComponent: <Tree />
    },
    foreignAffairs: {
      title: "Foreign Affairs",
      iconComponent: <Globe2 />
    },
    health: {
      title: "Health",
      iconComponent: <HealthIcon />
    },
    immigration: {
      title: "Immigration",
      iconComponent: <ImmigrationIcon />
    },
    infrastructure: {
      title: "Infrastructure",
      iconComponent: <InfrastructureIcon />
    },
    justice: {
      title: "Justice",
      iconComponent: <JusticeIcon />
    },
    science: {
      title: "Science & Tech",
      iconComponent: <ScienceIcon />
    },
    spending: {
      title: "Spending",
      iconComponent: <SpendingIcon />
    },
    regulations: {
      title: "Regulations",
      description: "Federal regulations and rulemaking from regulatory agencies. Includes proposed rules, final rules, notices, and supporting materials from the Federal Register and Regulations.gov.",
      iconComponent: <RegulationsIcon />,
      learnMoreLink: "https://www.regulations.gov/",
      externalLinks: [
        { label: "regulations.gov", url: "https://www.regulations.gov/" },
        { label: "Federal Register", url: "https://www.federalregister.gov/" }
      ]
    }
  }
};

export default sectionsInfo;